import { kennzahlenForm } from "../../data/data";

export const BASIS_FIELDS = kennzahlenForm.steps[0].fields;
export const RISIKO_FIELDS = kennzahlenForm.steps[1].fields;
export const MITARBEITER_FIELDS = kennzahlenForm.steps[2].fields;

export const EMP_FUNCTIONS = [
  "Büro/Verwaltung/Finanzen",
  "Marketing",
  "Vertrieb",
  "Entwickler",
  "Projektmanager",
  "Werkstatt/Produktion",
  "Arbeiten auf fremden Grundstücken",
  "Werkstudenten",
  "Sonstige",
];

export const EMP_TYPES = ["V", "T", "A", "H", "P", "M", "GF", "F"] as const;
export type EmpType = (typeof EMP_TYPES)[number];

export const EMP_TYPE_LABELS: Record<EmpType, string> = {
  V: "Vollzeit",
  T: "Teilzeit",
  A: "Auszubildende",
  H: "Hilfskräfte",
  P: "Praktikanten",
  M: "Minijobber",
  GF: "Geschäftsführer",
  F: "Freelancer",
};

export const EMP_BOOLEAN_COLS = ["tarif", "schicht", "befristet"] as const;
export type EmpBoolCol = (typeof EMP_BOOLEAN_COLS)[number];

export const EMP_BOOLEAN_LABELS: Record<EmpBoolCol, string> = {
  tarif: "Tarifgebunden",
  schicht: "Schichtarbeit",
  befristet: "Befristet",
};

export const EMP_BOOLEAN_SHORT: Record<EmpBoolCol, string> = {
  tarif: "TG",
  schicht: "SA",
  befristet: "BF",
};

// Key inside the matrix JSON that holds per-function boolean flags.
// Keeps numeric matrix shape unchanged for existing consumers.
export const EMP_FLAGS_KEY = "__flags__";

export const isCurrencyField = (fieldType: string): boolean =>
  fieldType === "CurrencyInput";

export const isNumericField = (fieldName: string, fieldType: string): boolean => {
  if (fieldType === "CurrencyInput" || fieldType === "NumberInput") return true;
  return (
    fieldName.includes("Count") ||
    fieldName.includes("Km") ||
    fieldName.includes("Days") ||
    fieldName.includes("Pct") ||
    fieldName === "avgConcurrentPersons"
  );
};
